import React, { createContext, useContext, useState, useEffect, useCallback, useRef } from 'react';
import { apiFetch } from '../utils/api';

const NotificationContext = createContext({ counts: {}, refresh: () => {}, clearSection: () => {} });

function playTodoSound() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.type = 'sine';
    osc.frequency.setValueAtTime(880, ctx.currentTime);
    osc.frequency.exponentialRampToValueAtTime(660, ctx.currentTime + 0.15);
    gain.gain.setValueAtTime(0.4, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.5);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + 0.5);
  } catch {}
}

export function NotificationProvider({ children }) {
  const [counts, setCounts] = useState({});
  const intervalRef = useRef(null);
  const prevCountsRef = useRef({});

  const fetchCounts = useCallback(async () => {
    if (!localStorage.getItem('user')) return;
    try {
      const res = await apiFetch('/in-app-notifications/counts');
      const data = await res.json();
      if (data.success) {
        const newCounts = data.data;
        const prev = prevCountsRef.current;
        if ((newCounts.TODO || 0) > (prev.TODO || 0)) {
          playTodoSound();
        }
        prevCountsRef.current = newCounts;
        setCounts(newCounts);
      }
    } catch {
      // silent
    }
  }, []);

  useEffect(() => {
    fetchCounts();
    intervalRef.current = setInterval(fetchCounts, 30000);
    return () => clearInterval(intervalRef.current);
  }, [fetchCounts]);

  const clearSection = useCallback(async (section) => {
    setCounts(prev => ({ ...prev, [section]: 0 }));
    try {
      await apiFetch(`/in-app-notifications/read/${section}`, { method: 'PATCH' });
    } catch {
      // silent
    }
  }, []);

  return (
    <NotificationContext.Provider value={{ counts, refresh: fetchCounts, clearSection }}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotifications() {
  return useContext(NotificationContext);
}
